
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeAudio, requestNotificationPermission } from './utils/audioUtils';

// Initialize audio and request permissions on app start
const setupApp = async () => {
  if (typeof window !== 'undefined') {
    // Initialize audio system
    initializeAudio();
    
    // Request notification permission
    await requestNotificationPermission();
  }
};

// Run setup and render app
setupApp().catch(console.error);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
